import { makeStyles } from '@material-ui/core/styles';
import { LEFT_NAVIGATION_BAR_WIDTH, USERS_AND_ROLES_Z_INDEX } from '../utils/layers';
import { colors } from '../styles/theme';
import { MOBILE_BREAKPOINT } from '../utils/utilityHelper';

export const useSharedStyles = makeStyles(theme => ({
  root: {
    zIndex: USERS_AND_ROLES_Z_INDEX,
    position: 'fixed',
    left: 70,
    width: `calc(100vw - ${LEFT_NAVIGATION_BAR_WIDTH}px)`,
    height: '100%',
    backgroundColor: colors.white,
    display: 'flex',
    flexDirection: 'column',
    padding: '20px 50px 42px',
    overflowY: 'hidden',
    scrollbarWidth: 'none',
    '-ms-overflow-style': 'none',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
    [theme.breakpoints.down(MOBILE_BREAKPOINT)]: {
      left: 0,
      width: '100vw',
      padding: '20px 16px',
    },
  },
  title: {
    color: colors.black0,
    fontStyle: 'normal',
    fontSize: 24,
    fontWeight: 500,
    marginBottom: 10,
  },
  divider: {
    background: colors.black10,
    marginBottom: 20,
  },
  loader: {
    display: 'flex',
    justifyContent: 'center',
    margin: theme.spacing(2),
  },
}));
